import { ReactElement } from 'react'
import { Button } from '@mui/material'
import type { ShearConnectionDTO } from '@api/fastAPI.schemas'
import { SaveButton } from '@ui/actions'
import { DialogBase } from '@ui/feedback'
import ShearConnectionForm from '../ShearConnectionForm'

const FORM_ID = 'shear-connection-edit-form'

interface Props {
  open: boolean
  onClose: () => void
  connection: ShearConnectionDTO
  takenShortNames: string[]
  isSaving: boolean
  onSave: (values: ShearConnectionDTO) => Promise<unknown>
}

const EditShearConnectionDialog = ({
  open,
  onClose,
  connection,
  takenShortNames,
  isSaving,
  onSave,
}: Props): ReactElement => {
  const handleSubmit = async (data: ShearConnectionDTO) => {
    await onSave({ ...data, guid: connection.guid })
    onClose()
  }

  return (
    <DialogBase
      open={open}
      onClose={onClose}
      title={`${connection.name} editieren`}
      dialogProps={{ maxWidth: 'lg', fullWidth: true }}
    >
      <ShearConnectionForm
        defaultValues={connection}
        id={FORM_ID}
        onSubmit={handleSubmit}
        takenShortNames={takenShortNames}
      />
      <>
        <Button size="small" onClick={onClose}>
          Abbrechen
        </Button>
        <SaveButton loading={isSaving} form={FORM_ID} type="submit">
          Speichern
        </SaveButton>
      </>
    </DialogBase>
  )
}

export default EditShearConnectionDialog
